import { LoadingButton } from '@mui/lab';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isLoadingSelector } from 'src/store/selectors/statusSelector';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  RESEND_KYC_DOC_TO_SIGN,
  resendKYCDocToSignAction
} from 'src/store/actions/investorActions';
import useStyles from './styles';

const ResendSigningLinkKYCButton = ({
  investorId,
  buttonText = 'COMMON.RESEND_SIGNING_URL',
  ...rest
}) => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const loadingResendKYC = useSelector(
    isLoadingSelector([RESEND_KYC_DOC_TO_SIGN.action])
  );

  const handleResendKYCSigningLink = useCallback(() => {
    dispatch(resendKYCDocToSignAction(investorId));
  }, [investorId, dispatch]);

  return (
    <LoadingButton
      {...rest}
      variant="contained"
      color="primary"
      onClick={handleResendKYCSigningLink}
      loading={loadingResendKYC}
      loadingPosition="start"
      className={classes.buttons}
      startIcon={<RefreshIcon />}
    >
      {t(buttonText)}
    </LoadingButton>
  );
};

export default ResendSigningLinkKYCButton;

ResendSigningLinkKYCButton.propTypes = {
  investorId: PropTypes.string.isRequired,
  buttonText: PropTypes.string
};
